// extracted by mini-css-extract-plugin
export var authorLink = "Card-module--authorLink--24210";
export var contribution = "Card-module--contribution--2052f";
export var image = "Card-module--image--c2b61";
export var info = "Card-module--info--55e61";
export var picture = "Card-module--picture--e6d86";
export var root = "Card-module--root--391d3";
export var thumb = "Card-module--thumb--d9c8d";
export var title = "Card-module--title--2354c";
export var titleContainer = "Card-module--titleContainer--f4d93";
export var titleLink = "Card-module--titleLink--b121f";
export var videoLink = "Card-module--videoLink--07809";